<template>
  <div class="sidebar-inner" style="width: 100%;">
    <el-row style="margin-bottom: 1.25rem;">
      <el-col :span="2">
        <span class="step-circle">1</span>
      </el-col>
      <el-col :span="22" class="v2__heading">When was the contact's First Visit?</el-col>
    </el-row>

    <div style="margin-bottom: 2rem;">
      <el-row style="margin-bottom: 1rem;">
        <el-col :offset="2" :span="22">
          <el-radio-group v-model="timeframe">
            <el-radio label="absolute" border>Around static date(s)</el-radio>
            <el-radio label="relative" border>A relative time frame</el-radio>
            <el-radio label="entering_campaign" border v-if="goalList">Since entering campaign</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <el-row v-if="timeframe === 'absolute'">
        <el-col :offset="2" :span="22">
          <div class="options">
            <el-radio-group v-model="time_comparison">
              <el-radio-button label="before">Before</el-radio-button>
              <el-radio-button label="between">Between</el-radio-button>
              <el-radio-button label="after">After</el-radio-button>
            </el-radio-group>

            <div class="block" v-if="time_comparison && time_comparison !== 'between'">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="dates"
                type="date"
                placeholder="Pick a date">
              </el-date-picker>
            </div>

            <div class="block" v-if="time_comparison && time_comparison === 'between'">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="dates"
                type="daterange"
                range-separator="-"
                start-placeholder="Start"
                end-placeholder="End">
              </el-date-picker>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row v-if="timeframe === 'relative'">
        <el-col :offset="2" :span="22">
          <div class="options">
            <el-radio-group v-model="time_comparison">
              <el-radio-button label="more">At least</el-radio-button>
              <el-radio-button label="within">Within the last</el-radio-button>
              <el-radio-button label="exactly">Exactly</el-radio-button>
            </el-radio-group>
            <div class="block" style="display: flex; align-items: center;">
              <el-input-number :min="0" v-model="relative_days"></el-input-number>
              &nbsp;
              days<span v-if="time_comparison && time_comparison !== 'within'">&nbsp;ago</span>.
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row style="margin-bottom: 1.25rem;">
      <el-col :span="2">
        <span class="step-circle">2</span>
      </el-col>
      <el-col :span="22" class="v2__heading">Should the First Visit be of a specific type?</el-col>
    </el-row>

    <div style="margin-bottom: 2rem;">
      <el-row style="margin-bottom: 1rem;">
        <el-col :offset="2" :span="22">
          <el-radio-group v-model="filter_plan">
            <el-radio :label="false" border>Any type</el-radio>
            <el-radio :label="true" border>Specific type(s)</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <el-row style="margin-bottom: 2rem;" v-if="filter_plan">
        <el-col :offset="2" :span="22">
          <div class="options">
            <el-form>
              <label>Select your Plan(s)</label>
              <el-form-item>
                <el-select v-model="selected_plans" multiple filterable placeholder="Plans" style="width: 100%;">
                  <el-option v-for="plan in plans" :key="plan.name" :value="plan.name" :id="plan.name"></el-option>
                </el-select>
              </el-form-item>

              <label>Service Type(s)</label>
              <el-form-item>
                <el-select v-model="selected_types" multiple filterable placeholder="Service Types" style="width: 100%;">
                  <el-option v-for="type in types" :key="type.name" :value="type.name" :id="type.name" style="text-transform: uppercase;"></el-option>
                </el-select>
              </el-form-item>

              <label>Service Categorie(s)</label>
              <el-form-item>
                <el-select v-model="selected_revenue_categories" multiple filterable placeholder="Service Categories" style="width: 100%;">
                  <el-option v-for="category in categories" :key="category.name" :value="category.name" :id="category.name"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-form>
      <el-form-item>
        <el-button type="primary" class="xpl-button xpl-button--primary" @click.stop="commitCondition">Save this condition</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import EventBus from '@/event-bus';
  import * as api from '@/api';

  export default {
    props: ['condition', 'editedRule', 'enrollment', 'goalList'],
    data() {
      return {
        timeframe: null,
        time_comparison: null,
        dates: null,
        relative_days: null,
        filter_plan: false,
        selected_plans: [],
        plans: [],
        selected_types: [],
        types: [],
        selected_revenue_categories: [],
        categories: [],
      };
    },
    created() {
      this.fetchPlans();
      this.fetchTypes();
      this.fetchCategories();

      if (this.editedRule) {
        this.timeframe = this.editedRule.timeframe;
        this.time_comparison = this.editedRule.time_comparison;
        this.relative_days = this.editedRule.relative_days;

        if (this.editedRule.end_date) {
          this.dates = [this.editedRule.start_date, this.editedRule.end_date];
        } else {
          this.dates = this.editedRule.start_date;
        }

        this.selected_plans = this.editedRule.plans;
        this.selected_types = this.editedRule.types;
        this.selected_revenue_categories = this.editedRule.categories;

        if (this.selected_plans.length ||
          this.selected_types.length ||
          this.selected_revenue_categories.length) {
          this.filter_plan = true;
        }
      }
    },
    methods: {
      fetchPlans() {
        api.getPersonPlans().then((response) => {
          this.plans = response.plans;
        }).catch((err) => {
          this.$toasted.error(err.message);
        });
      },
      fetchTypes() {
        api.getPlanTypes().then((response) => {
          this.types = response.types;
        }).catch((err) => {
          this.$toasted.error(err.message);
        });
      },
      fetchCategories() {
        api.getPlanCategories().then((response) => {
          this.categories = response.categories;
        }).catch((err) => {
          this.$toasted.error(err.message);
        });
      },
      commitCondition() {
        const payload = {
          condition: {
            uuid: this.condition.uuid,
            name: this.condition.name,
            unique: this.condition.unique,
          },
          timeframe: this.timeframe,
          time_comparison: this.time_comparison,
          start_date: Array.isArray(this.dates) ? this.dates[0] : this.dates,
          end_date: Array.isArray(this.dates) ? this.dates[1] : null,
          relative_days: this.relative_days,
          filter_plan: this.filter_plan,
          plans: this.selected_plans,
          types: this.selected_types,
          categories: this.selected_revenue_categories,
        };

        EventBus.$emit('conditions_selection.commit', payload);
      },
    },
  };
</script>
<style lang="scss" scoped>
 .options {
    padding: 1.25rem;
    background-color: #f5f8fb;
  }
</style>
